var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 103.991,
    height: 103.991,
    viewBox: "0 0 103.991 103.991",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "flare_1",
    fill: "#e4e3c2",
    d: "M3069.177-102.925h0a78.317,78.317,0,0,0-52,52h0a78.323,78.323,0,0,0-52-52h0a78.322,78.322,0,0,0,52-52h0a78.317,78.317,0,0,0,52,52Z",
    "data-name": "flare 1",
    transform: "translate(-2965.186 154.92)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlare);
export default __webpack_public_path__ + "static/media/flare.556ea4f912be5f02987f9ec1bc46de23.svg";
export { ForwardRef as ReactComponent };